(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoAfericoesWrapperCtrl', HistoricoAfericoesWrapper);

  HistoricoAfericoesWrapper.$inject = [
    '$scope',
    '$routeParams',
    '$route',
    '$rootScope'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function HistoricoAfericoesWrapper($scope, $routeParams, $route, $rootScope) {
    const vm = this;

    // Controller data
    vm.activeTab = null;
    vm.open = false;
    vm.disabled = {
      semeadura_afericao: true,
      colheita_afericao: true
    };

    // Bindable methods
    vm.activate = activate;

    // Function declarations
    function activate(tab = null) {
      $route.updateParams({
        activeTab: tab,
        activeAfericao: null
      });
    }

    // Controller logic
    $rootScope.initialize.then(() => {
      const permissions = Object.keys(vm.disabled);
      permissions.forEach((key) => {
        vm.disabled[key] = !$rootScope.permissions[key].canRead;
        if (!vm.disabled[key] && !vm.activeTab) {
          vm.activeTab = key;
        }
      });
    });

    $scope.$watch('sidebar', function(value) {
      if (value === 'historicoAfericoes') {
        if ($routeParams.activeTab) {
          vm.activeTab = $routeParams.activeTab;
        }
        vm.open = true;
      }
    });

    $scope.$watch('wrap.activeTab', function(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        activate(newVal);
      }
    });

    $scope.$on('$destroy', function() {
      activate();
    });
  }
}());
